package co.maytes.standupbot.dashboard.features.onboarding

data class SchedulePreset(val hour: Int, val minute: Int, val days: List<String>) {
    val timeLabel: String get() = SchedulePresets.clockLabel(hour, minute)

    fun matches(selectedDays: List<String>, selectedHour: Int, selectedMinute: Int): Boolean =
        hour == selectedHour && minute == selectedMinute && days.toSet() == selectedDays.toSet()
}

object SchedulePresets {
    private const val MINUTES_PER_HOUR = 60
    private const val NOON_HOUR = 12

    val weekdays = listOf("MON", "TUE", "WED", "THU", "FRI")

    val all = listOf(
        SchedulePreset(9, 30, weekdays),
        SchedulePreset(11, 0, weekdays),
        SchedulePreset(16, 0, weekdays),
    )

    fun clockLabel(hour: Int, minute: Int): String {
        val period = if (hour < NOON_HOUR) "AM" else "PM"
        val twelveHour = if (hour % NOON_HOUR == 0) NOON_HOUR else hour % NOON_HOUR
        val minutes = (minute % MINUTES_PER_HOUR).toString().padStart(2, '0')
        return "$twelveHour:$minutes $period"
    }

    fun describeDays(days: List<String>): String = when (days.toSet()) {
        weekdays.toSet() -> "Monday to Friday"
        else -> days.joinToString(", ") { it.lowercase().replaceFirstChar(Char::titlecase) }
    }
}
